/* globals BUILD_VERSION_ID:false */

import './js/main'
import './styles/main.scss'

if (window.NordLock) {
  window.NordLock.BUILD_VERSION_ID = BUILD_VERSION_ID
}
